import { getFeatureConfig } from '@luna/feature-config';
import type { SharedFeatureConfig } from '@shared/feature-config';
import { decodeJwtToken } from '@luna/utils';
import { isFeatureEnabled } from '@luna/gatekeeper';
import { logger } from '@luna/logger';
import { getAuthData } from '@luna/oidc';

function isUserAdvisor(): boolean {
    const token = getAuthData().idToken;
    if (!token) {
        return false;
    }
    try {
        const parsedToken = decodeJwtToken<{ act?: { sub: string; realm: string } }>(token);
        return !!parsedToken?.act;
    } catch (e) {
        logger.warn('Failed to detect advisory user', e);
        return false;
    }
}

export function getAutoLogoutConfigOverride(): SharedFeatureConfig['autoLogout'] | undefined {
    if (isFeatureEnabled((f) => f.advisorAutoLogoutOverride) && isUserAdvisor()) {
        return getFeatureConfig((f) => f.advisorAutoLogout);
    }
    return undefined;
}
